import { render } from "./threePClaim.vue?vue&type=template&id=d6a9f5b0&scoped=true"
import script from "./threePClaim.vue?vue&type=script&lang=js"
export * from "./threePClaim.vue?vue&type=script&lang=js"

import "./threePClaim.vue?vue&type=style&index=0&id=d6a9f5b0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6a9f5b0"]])

export default __exports__